(function() {
  var DrawToolbar,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DrawToolbar = App.loadClass('core::DrawToolbar');

  exports.DrawToolbarZones = (function(superClass) {
    extend(DrawToolbarZones, superClass);

    function DrawToolbarZones(zones) {
      var id;
      if (zones == null) {
        zones = null;
      }
      this._colorSetByColor = bind(this._colorSetByColor, this);
      this._firstUnusedColor = bind(this._firstUnusedColor, this);
      this._polySelected = bind(this._polySelected, this);
      this._initSelectTool = bind(this._initSelectTool, this);
      this._selectPressed = bind(this._selectPressed, this);
      this.reselectZone = bind(this.reselectZone, this);
      this._undoPressed = bind(this._undoPressed, this);
      this.colorSets = [
        {
          color: '#303F99',
          in_use: false
        }, {
          color: '#F2DC10',
          in_use: false
        }, {
          color: '#F08A2E',
          in_use: false
        }, {
          color: '#D51F26',
          in_use: false
        }, {
          color: '#00ACE1',
          in_use: false
        }, {
          color: '#A65392',
          in_use: false
        }, {
          color: '#EB468C',
          in_use: false
        }, {
          color: '#008161',
          in_use: false
        }, {
          color: '#974B19',
          in_use: false
        }, {
          color: '#36415A',
          in_use: false
        }, {
          color: '#231F20',
          in_use: false
        }
      ];
      this.currentColorSet = -1;
      this.selectedFeature = ko.observable();
      DrawToolbarZones.__super__.constructor.call(this);
      if ((zones == null) || zones.getLayers().length === 0) {
        this.zones = new L.FeatureGroup();
      } else {
        this.zones = zones.cloneGeom();
        id = 0;
        this.zones.eachLayer((function(_this) {
          return function(i) {
            var set;
            id++;
            if (i._cloneProperties == null) {
              i._cloneProperties = {};
            }
            if (i._cloneProperties.colorSet == null) {
              _this.cycleColorSets();
              i._cloneProperties.colorSet = $.extend({}, _this.drawnOptions);
            } else {
              set = _this._colorSetByColor(i._cloneProperties.colorSet.color);
              if (set !== -1) {
                _this.colorSets[set].in_use = true;
              }
            }
            if (i._cloneProperties.id == null) {
              i._cloneProperties.id = id;
            }
            return L.GeoUtil.setNestedStyles(i, i._cloneProperties.colorSet);
          };
        })(this));
        this._setDrawnItems(this.zones.getLayers()[0]);
        this.zones.cleanUp();
      }
      App.map.addLayer(this.zones);
      this.undoStack = new L.GeomUndoStack(this.zones);
    }

    DrawToolbarZones.prototype._undoPressed = function() {
      this.undoStack.undo();
      return this.reselectZone();
    };

    DrawToolbarZones.prototype.reselectZone = function() {
      var foundLayer;
      foundLayer = null;
      this.zones.eachLayer((function(_this) {
        return function(l) {
          if (l._cloneProperties.id === _this.selectedFeature()) {
            return foundLayer = l;
          }
        };
      })(this));
      if (foundLayer == null) {
        foundLayer = this.zones.getLayers()[0];
      }
      if (this.lastClicked() === 'draw-select') {
        this.drawControl.getButton('draw-select').trigger('click');
        return this._polySelected({
          target: foundLayer
        });
      } else {
        return this._setDrawnItems(foundLayer);
      }
    };

    DrawToolbarZones.prototype.initDrawnItems = function() {
      var ref;
      if ((this.drawnItems == null) && this.zones.getLayers().length > 0) {
        this._setDrawnItems(this.zones.getLayers()[0]);
        return;
      }
      this.undoStack.push();
      this.drawnItems = new L.FeatureGroup();
      this.drawnItems._cloneProperties = {};
      this.drawnItems._cloneProperties.id = (new Date()).getTime();
      this.selectedFeature(this.drawnItems._cloneProperties.id);
      this.zones.addLayer(this.drawnItems);
      this.cycleColorSets();
      this.drawnItems._cloneProperties.colorSet = $.extend({}, this.drawnOptions);
      this.prevState = this.drawnItems.cloneGeom();
      if ((typeof this.lastClicked === "function" ? this.lastClicked() : void 0) != null) {
        if ((ref = this.lastClicked()) === 'draw-poly-add' || ref === 'draw-poly-sub' || ref === 'draw-rect-add' || ref === 'draw-rect-sub' || ref === 'draw-circle-add' || ref === 'draw-circle-sub') {
          this.drawControl.getButton(this.lastClicked()).trigger('click');
        }
      }
      return this.fire('zone:added', this.drawnItems);
    };

    DrawToolbarZones.prototype.deleteZone = function(zone) {
      var ref, ref1, set;
      if (((ref = zone._cloneProperties.colorSet) != null ? ref.color : void 0) != null) {
        set = this._colorSetByColor(zone._cloneProperties.colorSet.color);
        if (set !== -1) {
          this.colorSets[set].in_use = false;
        }
      }
      if (zone._cloneProperties.id === this.drawnItems._cloneProperties.id) {
        if (((ref1 = this.currentTool()) != null ? ref1.disable : void 0) != null) {
          this.currentTool().disable();
          this.drawControl.deselectBtn(this.lastClicked());
        }
      }
      if (this.zones.hasLayer(zone)) {
        this.undoStack.push();
        this.zones.removeLayer(zone);
      }
      App.map.removeLayer(zone);
      if (zone._cloneProperties.id === this.drawnItems._cloneProperties.id) {
        this._setDrawnItems(this.zones.getLayers()[0]);
      }
      return this.fire('zone:deleted', zone);
    };

    DrawToolbarZones.prototype.destroy = function() {
      DrawToolbarZones.__super__.destroy.call(this);
      if (this.zones != null) {
        return App.map.removeLayer(this.zones);
      }
    };

    DrawToolbarZones.prototype._selectPressed = function() {
      var i, j, len, ref;
      ref = this.getZones();
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        i.on('click', this._polySelected);
      }
      this.fire('select:no-poly');
      return this._initSelectTool();
    };

    DrawToolbarZones.prototype._initSelectTool = function() {
      var self;
      self = this;
      return this.currentTool({
        h: null,
        disable: function() {
          var i, j, k, len, len1, ref, ref1, results;
          if ((this.h != null) && (this.h.disable != null)) {
            this.h.disable();
          }
          if ($.isArray(this.h)) {
            ref = this.h;
            for (j = 0, len = ref.length; j < len; j++) {
              i = ref[j];
              i.disable();
            }
          }
          ref1 = self.getZones();
          results = [];
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            i = ref1[k];
            results.push(i.off('click', self._polySelected));
          }
          return results;
        }
      });
    };

    DrawToolbarZones.prototype._setDrawnItems = function(geom) {
      if (geom == null) {
        return;
      }
      this.drawnItems = geom;
      this.selectedFeature(this.drawnItems._cloneProperties.id);
      this.prevState = this.drawnItems.cloneGeom();
      return this._setColorSet(this.drawnItems._cloneProperties.colorSet.fillColor);
    };

    DrawToolbarZones.prototype._polySelected = function(e, ee) {
      var handlers, i, j, len, ref;
      handlers = [];
      this._setDrawnItems(e.target);
      this.prevState = this.drawnItems.cloneGeom();
      this.drawnOptions = $.extend({}, this.drawnItems._cloneProperties.colorSet);
      this.drawnItems.bringToFront();
      this.drawnItems.eachLayer((function(_this) {
        return function(layer) {
          var handler;
          handler = new L.Edit.PolyWithHoles(layer, {
            successColor: _this.drawnItems._cloneProperties.colorSet.fillColor
          });
          handler.enable();
          handlers.push(handler);
          handler.on('geometry-invalid', function() {
            _this.fire('edit:geometry-invalid');
            return _this.drawnItems.isInvalid = true;
          });
          return handler.on('geometry-valid', function() {
            _this.drawnItems.isInvalid = false;
            return _this.fire('edit:geometry-valid');
          });
        };
      })(this));
      this.fire('select:poly-selected');
      if ((typeof this.currentTool === "function" ? this.currentTool() : void 0) != null) {
        if ((this.currentTool().h != null) && (this.currentTool().h.disable != null)) {
          this.currentTool().h.disable();
        }
        if ($.isArray(this.currentTool().h)) {
          ref = this.currentTool().h;
          for (j = 0, len = ref.length; j < len; j++) {
            i = ref[j];
            i.disable();
          }
        }
      }
      return this.currentTool().h = handlers;
    };

    DrawToolbarZones.prototype.initShapeDefaults = function() {
      var opts;
      opts = DrawToolbarZones.__super__.initShapeDefaults.call(this);
      opts.shape.fillColor = this.colorSets[this.currentColorSet];
      opts.shape.color = opts.shape.fillColor;
      opts.shape.fillOpacity = 0.6;
      return opts;
    };

    DrawToolbarZones.prototype.getZones = function() {
      return this.zones.getLayers();
    };

    DrawToolbarZones.prototype.cycleColorSets = function() {
      var set;
      this.currentColorSet = this._firstUnusedColor();
      if (this.currentColorSet !== -1) {
        set = this.colorSets[this.currentColorSet];
        set.in_use = true;
        return this._setColorSet(set.color);
      }
    };

    DrawToolbarZones.prototype._setColorSet = function(color) {
      this.drawnOptions.fillColor = color;
      this.drawnOptions.color = this.drawnOptions.fillColor;
      if (this.drawControl != null) {
        this.drawControl.options.draw.polygon.shapeOptions = this.drawnOptions;
        this.drawControl.options.draw.rectangle.shapeOptions = this.drawnOptions;
        this.drawControl.options.draw.circle.shapeOptions = this.drawnOptions;
        this.drawControl.options.polygon = this.drawnOptions;
        this.drawControl.options.rectangle = this.drawnOptions;
        return this.drawControl.options.circle = this.drawnOptions;
      }
    };

    DrawToolbarZones.prototype._firstUnusedColor = function() {
      var i, ind, j, keep_trying, len, new_color, ref;
      ref = this.colorSets;
      for (ind = j = 0, len = ref.length; j < len; ind = ++j) {
        i = ref[ind];
        if (i.in_use === false) {
          return ind;
        }
      }
      keep_trying = true;
      while (keep_trying !== void 0) {
        new_color = '#' + ((Math.random() * 0xFFFFFF) << 0).toString(16);
        if (new_color.length === 7) {
          keep_trying = _.find(this.colorSets, (function(_this) {
            return function(set) {
              return set.color === new_color;
            };
          })(this));
        }
      }
      this.colorSets.push({
        color: new_color,
        in_use: false
      });
      return this.colorSets.length - 1;
    };

    DrawToolbarZones.prototype._colorSetByColor = function(color) {
      var i, ind, j, len, ref;
      ref = this.colorSets;
      for (ind = j = 0, len = ref.length; j < len; ind = ++j) {
        i = ref[ind];
        if (i.color === color) {
          return ind;
        }
      }
      return -1;
    };

    DrawToolbarZones.prototype.createZoneFromRemainingArea = function(field) {
      var copy, diff, err, geom, group, i, j, len, ref;
      copy = this.zones.cloneGeom();
      if (L.GeoUtil.getSumAcreage(copy) === 0) {
        diff = field.cloneGeom();
      } else {
        group = new L.FeatureGroup();
        L.GeoUtil.unnestAdd(group, copy);
        geom;
        ref = group.getLayers();
        for (j = 0, len = ref.length; j < len; j++) {
          i = ref[j];
          if (typeof geom === "undefined" || geom === null) {
            geom = L.GeoUtil.readFromJSTS(i);
            continue;
          }
          geom = L.GeoUtil.combine(geom, i, 'union');
        }
        try {
          diff = L.GeoUtil.combine(field, geom, 'difference');
        } catch (error) {
          err = error;
          console.log('ERROR COMBINING');
          console.log(err);
        }
        if (diff != null) {
          diff = L.GeoUtil.readFromJSTS(diff);
        } else {
          diff = field.cloneGeom();
        }
        this.initDrawnItems();
      }
      L.GeoUtil.unnestAdd(this.drawnItems, diff);
      return L.GeoUtil.setNestedStyles(this.drawnItems, this.drawnItems._cloneProperties.colorSet);
    };

    return DrawToolbarZones;

  })(DrawToolbar);

}).call(this);
